import { jsx } from 'panel';
import { ResourceType } from 'common/widgets/property-filter-menu/models/types';
import { RowNumericAggregator, RowNumericProperty, RowNumericSubAggregator } from 'common/widgets/query-entry-section/components/aggregations';
import { BehaviorRowDateRange } from 'common/widgets/query-entry-section/components/behaviors';
import { RowFilters } from 'common/widgets/query-entry-section/components/filters';
import { RowSelector } from 'common/widgets/query-entry-section/components/selector';
import { EntryPart } from 'common/widgets/query-entry-section/types';
import { StepRangeSelectorEl } from 'common/widgets/step-range-selector';
import { BaseEntryRowEl } from '../base/template';
/**
 * QuerySuperEntryRow is a catch-all renderer for all type of rows
 */

export function SuperEntryRowEl(_ref) {
  let {
    section,
    entry,
    index
  } = _ref;

  const selectorRenderer = () => jsx(null, null, jsx(RowSelector, {
    el: section,
    entry: entry,
    index: index,
    isPlaceholder: !this.hasEventValue()
  }), this.hasEventValue() && section.helpers.isExclusionStepsSection() && jsx(StepRangeSelectorEl, {
    attrs: {
      selected: JSON.stringify(section.helpers.exclusionSteps.getExclusionStep(index)),
      'num-steps': section.helpers.exclusionSteps.getNumExclusionSteps(),
      theme: "select",
      label: "between"
    },
    on: {
      select: ev => section.helpers.exclusionSteps.onExclusionStepSelected(ev, index)
    }
  }), section.attr("metrics-mode") && entry.type !== ResourceType.Cohort && jsx(RowNumericAggregator, {
    el: section,
    entry: entry,
    index: index
  }), section.helpers.canPerformPropertyAggregation(entry) && jsx(RowNumericProperty, {
    el: section,
    entry: entry,
    index: index,
    isPlaceholder: !this.hasPropertyValue()
  }), section.helpers.isDateRangeType(entry.type) && jsx(BehaviorRowDateRange, {
    el: section,
    entry: entry,
    index: index
  }), section.attr("metrics-mode") && entry.type !== ResourceType.Cohort && jsx(RowNumericSubAggregator, {
    el: section,
    entry: entry,
    index: index
  }));

  const bodyRowRenderer = () => jsx(null, null, jsx("div", {
    sel: '.mp-query-entry-row.for-filters'
  }, jsx(RowFilters, {
    el: section,
    entry: entry,
    index: index,
    source: EntryPart.Filters,
    handleUpdate: ev => this.handleFilterSectionUpdate(ev, EntryPart.Filters)
  }), jsx(RowFilters, {
    el: section,
    entry: entry,
    index: index,
    source: EntryPart.BehavioralFilters,
    handleUpdate: ev => this.handleFilterSectionUpdate(ev, EntryPart.BehavioralFilters)
  })));

  return jsx(BaseEntryRowEl, {
    index: index,
    el: section,
    entry: entry,
    rowRenderer: {
      prefixRenderer: null,
      selectorRenderer,
      bodyRowRenderer,
      suffixRenderer: null
    },
    isPlaceholder: this.isPlaceholder()
  });
}